module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/about/about.component.scss
// module id = ./src/app/components/views/about/about.component.scss
// module chunks = main